import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { memo } from 'react';
import { CertificateRadio, CertificateType } from 'civil-status/view-models/document-birth-form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { HttpResponseList } from 'shell/models/http-response';
import { CertificateTypeANPRList } from 'shell/models/certificate-type';

export const ID_ESTRATTO_CITTADINANZA = 'C2';
export const ID_COPIA_INTEGRALE_CITTADINANZA = 'C3';
export const ID_ESTRATTO_MORTE = 'D2';
export const ID_COPIA_INTEGRALE_MORTE = 'D3';
export const D4 = 'D4';
export const N1 = 'N1';
export const N2 = 'N2';
export const N3 = 'N3';
export const N4 = 'N4';
export const ID_COPIA_INTEGRALE_NASCITA = 'N3';
export const M1 = 'M1';
export const M2 = 'M2';
export const M3 = 'M3';
export const M4 = 'M4';
export const ID_COPIA_INTEGRALE_MATRIMONIO = 'M3';
export const U2 = 'U2';
export const U3 = 'U3';

interface CivilStatusCertificateProps {
  selectedValue?: string;
  type?: CertificateType;
  onChange: (value: CertificateRadio) => void;
  label?: string;
  id?: string;
  isAnsc?: boolean;
}

const CivilStatusCertificateComponent = ({
  selectedValue,
  onChange,
  label,
  id,
  type,
  isAnsc,
}: CivilStatusCertificateProps): React.ReactElement => {
  const [certifications] = useHttpFetch<
    HttpResponseList<CertificateTypeANPRList>,
    Array<CertificateRadio>
  >(`${__CERTIFICATION_API_URL__}/certificazione/tipi-documento/stato-civile`, {
    onBootstrap: true,
    options: {
      method: 'GET',
      loading: true,
      errorCatching: true,
      params: {
        flagAnsc: isAnsc,
        tipoAtto: type,
      },
    },
    transformer: (response) => {
      return response.data.payload.list.map((item, index) => ({
        value: item.descrizioneTipoDocumento,
        element: item,
        type,
        id: index + 1,
      }));
    },
  });

  const certificationsData = (certifications.data as Array<CertificateRadio>) || [];

  return (
    <FormControl component="fieldset">
      <FormLabel id={`${label}-id-label`}></FormLabel>
      {/* <Grid item md={12}>
        <PmiTitleDivider>{label}</PmiTitleDivider>
      </Grid>
      <Grid item md={12}>
        <Divider />
      </Grid> */}
      <RadioGroup
        row
        aria-label={label}
        id={id}
        value={selectedValue || ''}
        onChange={(event) => {
          const item = certificationsData.find((item1) => item1.value === event.target.value);
          onChange({
            value: event.target.value as string,
            type,
            element: item?.element as CertificateTypeANPRList,
          });
        }}
      >
        {certificationsData.map((certification, index) => (
          <FormControlLabel
            key={`${certification.type}_${certification.value}_${index}`}
            value={certification.value}
            control={<Radio />}
            label={certification.value}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

CivilStatusCertificateComponent.displayName = 'Civil Status Certificate Component';

const CivilStatusCertificate = memo(CivilStatusCertificateComponent);

export default CivilStatusCertificate;
